(function() {
    'use strict';

    angular
        .module('auth')
        .controller('PartnerPartnerLogoutController', PartnerLogoutController);

    PartnerLogoutController.$inject = ['AuthService', '$state'];

    /* @ngInject */
    function PartnerLogoutController(AuthService, $state) {
        var vm = this;

        activate();

        function activate() {
            AuthService.logout().then(function () {
                $state.go('auth.partners.login');
            });
        }
    }
})();